export default "__VITE_ASSET__ZLRnh_1D__"